import React from "react";
import CrudManager from "../../common/CrudManager";
import { Shield, Edit2, Trash2 } from "lucide-react";

const RoleManager = ({ onClose }) => {
  const fields = [
    {
      name: "name",
      label: "Role Name",
      type: "text",
      placeholder: "e.g., Manager",
      required: true,
    },
    {
      name: "level",
      label: "Access Level",
      type: "number",
      placeholder: "1-10",
      required: true,
      min: 1,
      max: 100,
    },
    {
      name: "remark",
      label: "Remark",
      type: "textarea",
      placeholder: "Add notes about this role...",
      required: false,
      fullWidth: true,
      rows: 2,
    },
  ];

  const formatCreateData = (formData) => ({
    name: formData.name.trim(),
    level: parseInt(formData.level),
    remark: formData.remark?.trim() || undefined,
  });

  const formatUpdateData = (formData) => ({
    name: formData.name.trim(),
    level: parseInt(formData.level),
    remark: formData.remark?.trim() || undefined,
  });

  const getLevelColor = (level) => {
    if (level === 1) return "bg-red-100 text-red-700";
    if (level === 2) return "bg-orange-100 text-orange-700";
    if (level === 3) return "bg-blue-100 text-blue-700";
    return "bg-slate-100 text-slate-700";
  };

  const renderItem = (role, onEdit, onDelete) => (
    <div className="flex items-start justify-between w-full">
      <div className="flex items-start space-x-4 flex-1">
        <div className="w-12 h-12 bg-subidha-blue/10 rounded-xl flex items-center justify-center flex-shrink-0">
          <Shield className="w-6 h-6 text-subidha-blue" />
        </div>
        <div className="flex-1">
          <div className="flex items-center space-x-3 mb-2">
            <h3 className="text-lg font-black text-slate-900">{role.name}</h3>
            <span
              className={`text-xs font-black px-3 py-1 rounded-full ${getLevelColor(role.level)}`}
            >
              Level {role.level}
            </span>
          </div>
          {role.remark && (
            <p className="text-sm text-slate-500 font-medium mb-2">
              {role.remark}
            </p>
          )}
          <p className="text-xs text-slate-400">
            Created {new Date(role.createdAt).toLocaleDateString()}
          </p>
        </div>
      </div>
      <div className="flex items-center space-x-2">
        {onEdit && (
          <button
            onClick={() => onEdit(role)}
            className="p-2 text-slate-400 hover:text-subidha-blue hover:bg-blue-50 rounded-lg transition-all"
          >
            <Edit2 className="w-4 h-4" />
          </button>
        )}
        {onDelete && (
          <button
            onClick={() => onDelete(role)}
            className="p-2 text-slate-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition-all"
          >
            <Trash2 className="w-4 h-4" />
          </button>
        )}
      </div>
    </div>
  );

  return (
    <CrudManager
      title="Manage Roles"
      apiEndpoint="/roles"
      fields={fields}
      renderItem={renderItem}
      onClose={onClose}
      icon={Shield}
      emptyMessage="No roles yet. Create your first role!"
      formatCreateData={formatCreateData}
      formatUpdateData={formatUpdateData}
    />
  );
};

export default RoleManager;
